import { render } from "./AgregarUsuario.vue?vue&type=template&id=6196bbac&scoped=true"
import script from "./AgregarUsuario.vue?vue&type=script&lang=js"
export * from "./AgregarUsuario.vue?vue&type=script&lang=js"

import "./AgregarUsuario.vue?vue&type=style&index=0&id=6196bbac&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6196bbac"]])

export default __exports__